import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateRegionSearch = () => {
  const corporateRegionSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/region/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateRegionSearch }
}

export default InteractorCorporateRegionSearch
